// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import API_BASE_URL from "../config/api";
import "./AdminHome.css";
import "./StoreOrders.css";
import SidebarAd from "../Blog/SidebarAd";

function AdminHomeIcon({ size = 22 }) {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
            <path d="M12 3L4 9v12h5v-7h6v7h5V9z"/>
        </svg>
    );
}

function AdminDatabaseIcon({ size = 22 }) {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
            <path d="M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4zM4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4zm0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4z"/>
        </svg>
    );
}

const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString('en-IN', {
        day: 'numeric', month: 'short', year: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true
    });
};

export default function OrderDetails() {
    const { orderId } = useParams();
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [emailLogs, setEmailLogs] = useState([]);
    const [sendingEmail, setSendingEmail] = useState(false);
    
    const toggleSidebar = () => setSidebarOpen((v) => !v);

    const formatPrice = (price, currency = 'INR') => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: currency
        }).format(price);
    };

    useEffect(() => {
        fetchOrderDetails();
        fetchEmailLogs();
    }, [orderId]); // eslint-disable-line react-hooks/exhaustive-deps

    const fetchEmailLogs = async () => {
        try {
            const token = sessionStorage.getItem("token");
            const response = await fetch(`${API_BASE_URL}/store/orders/${orderId}/email-logs`, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            const data = await response.json();
            if (data.success) {
                setEmailLogs(data.data);
            }
        } catch (err) {
            console.error("Error fetching email logs:", err);
        }
    };

    const handleResendReceipt = async () => {
        if (!window.confirm("Are you sure you want to resend the receipt?")) return;
        setSendingEmail(true);
        try {
            const token = sessionStorage.getItem("token");
            const response = await fetch(`${API_BASE_URL}/store/orders/${orderId}/resend-receipt`, {
                method: 'POST',
                headers: { "Authorization": `Bearer ${token}` }
            });
            const data = await response.json();
            if (data.success) {
                alert("Email resent successfully");
                fetchEmailLogs();
            } else {
                alert("Failed: " + data.message);
            }
        } catch (err) {
            console.error("Error resending email:", err);
            alert("Error resending email");
        } finally {
            setSendingEmail(false);
        }
    };

    const fetchOrderDetails = async () => {
        try {
            setLoading(true);
            const token = sessionStorage.getItem("token");
            if (!token) {
                setError("Please log in to view order details.");
                setLoading(false);
                return;
            }

            // Using the new store endpoint or directly fetch by ID if API supports it
            // Based on orderRoutes, router.get('/orders/:orderId') is available
            const response = await fetch(`${API_BASE_URL}/store/orders/${orderId}`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = await response.json();

            if (data.success) {
                setOrder(data.data);
            } else {
                setError(data.message || "Failed to fetch order details");
            }
        } catch (err) {
            console.error("Error fetching order details:", err);
            setError("Error fetching order details");
        } finally {
            setLoading(false);
        }
    };

    const renderStatus = (order) => {
        const statusData = order.trackingDetails && order.trackingDetails.status;
        
        if (Array.isArray(statusData)) {
            const activeStatuses = statusData.filter(s => s.checked);
            if (activeStatuses.length > 0) {
                return activeStatuses.map(s => {
                    let text = s.status || "Placed";
                    if (s.message) text += ` - ${s.message}`;
                    return text;
                }).join(', ');
            }
        }

        const legacy = order.orderStatus;
        
        if (typeof legacy === 'string') {
            const lower = legacy.toLowerCase();
            if (lower === 'placed' || lower === 'confirmed') return "Yet to assign";
            return legacy;
        }

        if (typeof legacy === 'object' && legacy !== null) {
            return `${legacy.status || "placed"}${legacy.message ? ` - ${legacy.message}` : ""}`;
        }
        
        return "Yet to assign";
    };

    return (
        <div className="admin-container mx-auto w-full max-w-[1600px] px-[12px] py-[10px]">
            <div className="admin-shell flex gap-[12px]">
                <aside className={`admin-sidenav ${sidebarOpen ? "admin-sidenav-open" : "admin-sidenav-closed"} rounded-[12px] border border-slider bg-bg p-[8px] shadow-[0_2px_10px_rgba(0,0,0,0.06)]`}>
                    <nav className="admin-sidenav-nav">
                        <Link to="/admin" className="admin-sidenav-item">
                            <span className="admin-sidenav-icon">
                                <AdminHomeIcon />
                            </span>
                            {sidebarOpen && <span className="admin-sidenav-text">Home</span>}
                        </Link>
                        <Link to="/admin/database" className="admin-sidenav-item">
                            <span className="admin-sidenav-icon">
                                <AdminDatabaseIcon />
                            </span>
                            {sidebarOpen && <span className="admin-sidenav-text">Database</span>}
                        </Link>
                        {sidebarOpen && (
                            <div className="admin-sidenav-ads">
                                <SidebarAd />
                            </div>
                        )}
                    </nav>
                    <div className="admin-sidenav-footer">
                        <button type="button" className="admin-sidenav-toggle" onClick={toggleSidebar} aria-label="Toggle admin sidenav">
                            <i className={`fi fi-sr-arrow-square-right ${sidebarOpen ? "rotate-180" : ""}`}></i>
                        </button>
                    </div>
                </aside>
                
                <main className="admin-content flex-1">
                    <div className="admin-header-row m-[20px] flex items-center" style={{ display: 'flex', alignItems: 'center', margin: '20px' }}>
                        <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Order Details</h1>
                    </div>

                    {loading ? (
                        <div className="loading-state">Loading order details...</div>
                    ) : error ? (
                        <div className="error-state">{error}</div>
                    ) : order ? (
                        <div className="order-details-container rounded-[8px] bg-white p-[24px] shadow-[0_1px_3px_rgba(0,0,0,0.1)]" style={{ background: 'white', padding: '24px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                            {/* ── Order Information ── */}
                            <div className="details-section" style={{ marginBottom: '24px' }}>
                                <h2 style={{ fontSize: '1.25rem', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '16px' }}>Order Information</h2>
                                <div className="details-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
                                    <div><strong>Order ID:</strong> <span style={{ wordBreak: 'break-all' }}>{order.orderId}</span></div>
                                    <div><strong>Created At:</strong> {formatDate(order.createdAt)}</div>
                                    <div><strong>Updated At:</strong> {formatDate(order.updatedAt)}</div>
                                    <div><strong>Order Status:</strong> {renderStatus(order)}</div>
                                    <div><strong>Total Amount:</strong> {order.totalAmount != null ? formatPrice(order.totalAmount, order.currency) : 'N/A'}</div>
                                    <div><strong>Currency:</strong> {order.currency || 'INR'}</div>
                                </div>
                                {order.notes && (
                                    <div style={{ marginTop: '16px', padding: '12px', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '6px' }}>
                                        <strong>Notes:</strong> {order.notes}
                                    </div>
                                )}
                            </div>

                            {/* ── Customer Information ── */}
                            <div className="details-section" style={{ marginBottom: '24px' }}>
                                <h2 style={{ fontSize: '1.25rem', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '16px' }}>Customer Information</h2>
                                <div className="details-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
                                    <div><strong>Name:</strong> {(order.shippingAddress && order.shippingAddress.name) || (order.billingAddress && order.billingAddress.name) || 'N/A'}</div>
                                    <div><strong>Email:</strong> {order.email || 'N/A'}</div>
                                    <div><strong>Phone:</strong> {order.contactNumber || 'N/A'}</div>
                                    <div><strong>User ID:</strong> {order.userId || 'Guest'}</div>
                                </div>
                            </div>

                            {/* ── Addresses ── */}
                            <div className="details-section" style={{ marginBottom: '24px' }}>
                                <h2 style={{ fontSize: '1.25rem', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '16px' }}>Addresses</h2>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px' }}>
                                    <div>
                                        <h3 style={{ fontSize: '1rem', fontWeight: '600', marginBottom: '10px', color: '#374151' }}>Shipping Address</h3>
                                        <div className="address-box" style={{ background: '#f9fafb', padding: '12px', borderRadius: '6px', lineHeight: '1.7' }}>
                                            <div><strong>Name:</strong> {(order.shippingAddress && order.shippingAddress.name) || 'N/A'}</div>
                                            <div><strong>Street:</strong> {(order.shippingAddress && order.shippingAddress.street) || 'N/A'}</div>
                                            <div><strong>City:</strong> {(order.shippingAddress && order.shippingAddress.city) || 'N/A'}</div>
                                            <div><strong>State:</strong> {(order.shippingAddress && order.shippingAddress.state) || 'N/A'}</div>
                                            <div><strong>ZIP:</strong> {(order.shippingAddress && order.shippingAddress.zip) || 'N/A'}</div>
                                            <div><strong>Country:</strong> {(order.shippingAddress && order.shippingAddress.country) || 'N/A'}</div>
                                        </div>
                                    </div>
                                    <div>
                                        <h3 style={{ fontSize: '1rem', fontWeight: '600', marginBottom: '10px', color: '#374151' }}>Billing Address</h3>
                                        <div className="address-box" style={{ background: '#f9fafb', padding: '12px', borderRadius: '6px', lineHeight: '1.7' }}>
                                            <div><strong>Name:</strong> {(order.billingAddress && order.billingAddress.name) || 'N/A'}</div>
                                            <div><strong>Street:</strong> {(order.billingAddress && order.billingAddress.street) || 'N/A'}</div>
                                            <div><strong>City:</strong> {(order.billingAddress && order.billingAddress.city) || 'N/A'}</div>
                                            <div><strong>State:</strong> {(order.billingAddress && order.billingAddress.state) || 'N/A'}</div>
                                            <div><strong>ZIP:</strong> {(order.billingAddress && order.billingAddress.zip) || 'N/A'}</div>
                                            <div><strong>Country:</strong> {(order.billingAddress && order.billingAddress.country) || 'N/A'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ── Payment Information ── */}
                            <div className="details-section" style={{ marginBottom: '24px' }}>
                                <h2 style={{ fontSize: '1.25rem', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '16px' }}>Payment Information</h2>
                                <div className="details-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
                                    <div><strong>Method:</strong> {(order.payment && order.payment.method) || 'N/A'}</div>
                                    <div><strong>Transaction ID:</strong> <span style={{ wordBreak: 'break-all' }}>{(order.payment && order.payment.transactionId) || 'N/A'}</span></div>
                                    <div><strong>Status:</strong> {(order.payment && order.payment.status) || 'N/A'}</div>
                                </div>
                            </div>

                            {/* ── Products Ordered ── */}
                            <div className="details-section" style={{ marginBottom: '24px' }}>
                                <h2 style={{ fontSize: '1.25rem', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '16px' }}>Products Ordered</h2>
                                <div className="products-table-wrapper" style={{ overflowX: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ background: '#f9fafb', textAlign: 'left' }}>
                                                <th style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}>Product</th>
                                                <th style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}>Product ID</th>
                                                <th style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}>Type</th>
                                                <th style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}>Qty</th>
                                                <th style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}>Price</th>
                                                <th style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}>Subtotal</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {order.products && order.products.map((item, idx) => (
                                                <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                                                    <td style={{ padding: '12px' }}>
                                                        <div style={{ fontWeight: '500' }}>{item.title}</div>
                                                        {item.variants && Object.keys(item.variants).length > 0 && (
                                                            <div style={{ fontSize: '0.82rem', color: '#6b7280', marginTop: '2px' }}>
                                                                {typeof item.variants === 'object'
                                                                    ? Object.entries(item.variants).map(([k, v]) => `${k}: ${v}`).join(', ')
                                                                    : item.variants}
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td style={{ padding: '12px', fontSize: '0.8rem', color: '#6b7280', wordBreak: 'break-all' }}>
                                                        {item.productId
                                                            ? (typeof item.productId === 'object' ? (item.productId._id || JSON.stringify(item.productId)) : item.productId)
                                                            : 'N/A'}
                                                    </td>
                                                    <td style={{ padding: '12px' }}>{item.productType || 'N/A'}</td>
                                                    <td style={{ padding: '12px' }}>{item.quantity}</td>
                                                    <td style={{ padding: '12px' }}>{item.price != null ? formatPrice(item.price, order.currency) : 'N/A'}</td>
                                                    <td style={{ padding: '12px' }}>{item.subtotal != null ? formatPrice(item.subtotal, order.currency) : 'N/A'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr style={{ background: '#f9fafb' }}>
                                                <td colSpan="5" style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
                                                <td style={{ padding: '12px', fontWeight: 'bold' }}>{order.totalAmount != null ? formatPrice(order.totalAmount, order.currency) : 'N/A'}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>

                            {/* ── Discount Details ── */}
                            {order.discountDetails && order.discountDetails.length > 0 && (
                                <div className="details-section" style={{ marginBottom: '24px' }}>
                                    <h2 style={{ fontSize: '1.25rem', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '16px' }}>Discount Details</h2>
                                    <div style={{ overflowX: 'auto' }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr style={{ background: '#f9fafb', textAlign: 'left' }}>
                                                    <th style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Coupon Code</th>
                                                    <th style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Discount Type</th>
                                                    <th style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Discount Value</th>
                                                    <th style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Amount Off</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {order.discountDetails.map((d, idx) => (
                                                    <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                                                        <td style={{ padding: '10px' }}>{d.couponCode || 'N/A'}</td>
                                                        <td style={{ padding: '10px' }}>{d.discountType || 'N/A'}</td>
                                                        <td style={{ padding: '10px' }}>{d.discountValue != null ? d.discountValue : 'N/A'}</td>
                                                        <td style={{ padding: '10px' }}>{d.amountOff != null ? formatPrice(d.amountOff, order.currency) : 'N/A'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                            {/* ── Tracking Details ── */}
                            <div className="details-section" style={{ marginBottom: '24px' }}>
                                <h2 style={{ fontSize: '1.25rem', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '16px' }}>Tracking Details</h2>
                                <div className="details-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px', marginBottom: '16px' }}>
                                    <div><strong>Courier:</strong> {(order.trackingDetails && order.trackingDetails.courierName) || 'N/A'}</div>
                                    <div><strong>Tracking Number:</strong> {(order.trackingDetails && order.trackingDetails.trackingNumber) || 'N/A'}</div>
                                    <div>
                                        <strong>Tracking URL:</strong>{' '}
                                        {order.trackingDetails && order.trackingDetails.trackingUrl
                                            ? <a href={order.trackingDetails.trackingUrl} target="_blank" rel="noreferrer" style={{ color: '#4f46e5', wordBreak: 'break-all' }}>{order.trackingDetails.trackingUrl}</a>
                                            : 'N/A'}
                                    </div>
                                    <div><strong>Expected Delivery:</strong> {order.trackingDetails && order.trackingDetails.expectedDelivery ? formatDate(order.trackingDetails.expectedDelivery) : 'N/A'}</div>
                                    <div><strong>Shipped At:</strong> {order.trackingDetails && order.trackingDetails.shippedAt ? formatDate(order.trackingDetails.shippedAt) : 'N/A'}</div>
                                    <div><strong>Delivered At:</strong> {order.trackingDetails && order.trackingDetails.deliveredAt ? formatDate(order.trackingDetails.deliveredAt) : 'N/A'}</div>
                                </div>
                                {/* Status Timeline */}
                                {order.trackingDetails && Array.isArray(order.trackingDetails.status) && order.trackingDetails.status.length > 0 && (
                                    <div>
                                        <strong style={{ display: 'block', marginBottom: '10px' }}>Status Timeline:</strong>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                            {order.trackingDetails.status.map((s, idx) => (
                                                <div key={idx} style={{
                                                    display: 'flex', alignItems: 'flex-start', gap: '12px',
                                                    padding: '10px 14px', borderRadius: '6px',
                                                    background: s.checked ? '#f0fdf4' : '#f9fafb',
                                                    border: `1px solid ${s.checked ? '#bbf7d0' : '#e5e7eb'}`,
                                                    opacity: s.checked ? 1 : 0.6
                                                }}>
                                                    <span style={{ fontSize: '1rem', marginTop: '1px' }}>{s.checked ? '✅' : '⬜'}</span>
                                                    <div>
                                                        <div style={{ fontWeight: '600', fontSize: '0.9rem' }}>{s.status || 'Unnamed'}</div>
                                                        {s.message && <div style={{ fontSize: '0.82rem', color: '#6b7280', marginTop: '2px' }}>{s.message}</div>}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* ── Email History ── */}
                            <div className="details-section" style={{ marginBottom: '24px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '16px' }}>
                                    <h2 style={{ fontSize: '1.25rem', margin: 0 }}>Email History</h2>
                                    <button
                                        onClick={handleResendReceipt}
                                        disabled={sendingEmail}
                                        style={{
                                            background: '#4f46e5', color: 'white', border: 'none',
                                            padding: '8px 16px', borderRadius: '4px',
                                            cursor: sendingEmail ? 'not-allowed' : 'pointer', fontSize: '0.9rem'
                                        }}
                                    >
                                        {sendingEmail ? 'Sending...' : 'Resend Receipt'}
                                    </button>
                                </div>
                                <div className="email-logs-table-wrapper" style={{ overflowX: 'auto' }}>
                                    {emailLogs.length > 0 ? (
                                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
                                            <thead>
                                                <tr style={{ background: '#f9fafb', textAlign: 'left' }}>
                                                    <th style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Type</th>
                                                    <th style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Recipient</th>
                                                    <th style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Status</th>
                                                    <th style={{ padding: '10px', borderBottom: '1px solid #e5e7eb' }}>Sent At</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emailLogs.map((log, idx) => (
                                                    <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                                                        <td style={{ padding: '10px' }}>{log.emailType}</td>
                                                        <td style={{ padding: '10px' }}>{log.recipientEmail}</td>
                                                        <td style={{ padding: '10px' }}>
                                                            <span style={{
                                                                padding: '2px 8px', borderRadius: '12px',
                                                                background: log.status === 'SENT' ? '#dcfce7' : '#fee2e2',
                                                                color: log.status === 'SENT' ? '#166534' : '#991b1b',
                                                                fontSize: '0.8rem', fontWeight: '500'
                                                            }}>
                                                                {log.status}
                                                            </span>
                                                            {log.status === 'FAILED' && <div style={{ fontSize: '0.8rem', color: 'red', marginTop: '4px' }}>{log.errorMessage}</div>}
                                                        </td>
                                                        <td style={{ padding: '10px' }}>{formatDate(log.sentAt)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <p style={{ color: '#6b7280', textAlign: 'center', padding: '20px' }}>No emails sent yet.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="not-found">Order not found</div>
                    )}
                </main>
            </div>
        </div>
    );
}
